export default __webpack_public_path__ + "static/pimg2-631da961edf36b9abd38a8ba658ae5d5.jpg";